import template from './user-pay-agreements.html';
import userPayAgreementsController from './user-pay-agreements.controller';
import './user-pay-agreements.styl';

let userPayAgreementsComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
  },
  template,
  controller: userPayAgreementsController,
  controllerAs: 'vm'
};

export default userPayAgreementsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-pay-agreements/user-pay-agreements.component.js
 **/